<template functional>
    <div
        class="fflag flex-shrink-0"
        :class="['fflag-' + props.country, 'ff-' + props.size, props.border ? 'border' : '', {'ff-round': props.round, 'ff-app': props.app, 'rounded-sm': props.rounded}]"
    ></div>
</template>

<script>

export default {
    functional: true,
    name: 'CountryFlag',
    components: {},
    props: {
        country: {  // 2-letter country code, uppercase
            type: String,
            required: true,
        },
        size: {  // options:  sm, md, lg, xl
            type: String,
            default: 'md',
        },
        round: {  // show round style?  uses ff-round class
            type: Boolean,
            default: false,
        },
        app: {  // show square app-style?  uses ff-app class
            type: Boolean, 
            default: false,
        },
        rounded: { // puts a border radius on the corners, but not like round
            type: Boolean,
            default: false,
        },
        border: {  // optional... if set, puts a border around the flag
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style>

</style>